import smartCafe1 from "../assets/Smart Cafeteria System/1.png";
import smartCafe2 from "../assets/Smart Cafeteria System/2.png";
import smartCafe3 from "../assets/Smart Cafeteria System/3.png";
import smartCafe4 from "../assets/Smart Cafeteria System/4.png";
import smartCafe5 from "../assets/Smart Cafeteria System/5.png";
import smartCafe6 from "../assets/Smart Cafeteria System/6.png";
import smartCafe7 from "../assets/Smart Cafeteria System/7.png";
import smartCafe8 from "../assets/Smart Cafeteria System/8.png";
import smartCafe9 from "../assets/Smart Cafeteria System/9.png";
import smartCafe10 from "../assets/Smart Cafeteria System/10.png";
import smartCafe11 from "../assets/Smart Cafeteria System/11.png";
import smartCafe12 from "../assets/Smart Cafeteria System/12.png";
import smartCafe13 from "../assets/Smart Cafeteria System/13.png";

import AIchatbot1 from "../assets/AI Chatbot/1.png";
import AIchatbot2 from "../assets/AI Chatbot/2.png";

import gradeChecker1 from "../assets/Student Grade Checker/1.png";
import gradeChecker2 from "../assets/Student Grade Checker/2.png";
import gradeChecker3 from "../assets/Student Grade Checker/3.png";

import stock1 from "../assets/Stock Trading Platform/1.png";
import stock2 from "../assets/Stock Trading Platform/2.png";
import stock3 from "../assets/Stock Trading Platform/3.png";
import stock4 from "../assets/Stock Trading Platform/4.png";
import stock5 from "../assets/Stock Trading Platform/5.png";

import hotel1 from "../assets/Hotel Reservation System/1.png";
import hotel2 from "../assets/Hotel Reservation System/2.png";
import hotel3 from "../assets/Hotel Reservation System/3.png";

import moshify1 from "../assets/moshify Website/1.png";
import moshify2 from "../assets/moshify Website/2.png";
import moshify3 from "../assets/moshify Website/3.png";
import moshify4 from "../assets/moshify Website/4.png";
import moshify5 from "../assets/moshify Website/5.png";

import gameHubDark from "../assets/Game Hub/dark-mode.png";
import gameHubLight from "../assets/Game Hub/light-mode.png";

export const projectsData = [
  {
    id: 7,
    title: "Game Hub",
    description:
      "A responsive game discovery platform powered by the RAWG Video Games Database API. Users can search a large game catalog, filter by platform or genre, sort results, and open detailed pages with descriptions, trailers, screenshots, and game attributes.",
    images: [gameHubDark, gameHubLight],
    checklist: [
      "Responsive game grid with infinite scrolling",
      "Client-side search with query state management",
      "Platform, genre, and sort-order filtering",
      "Dedicated game detail pages with rich metadata",
      "Light and dark color modes for a personalized experience",
      "Loading skeletons and error handling for API-backed content",
    ],
    features: [
      "Browse popular games through a responsive card grid",
      "Search games by name with instant query updates",
      "Filter by platform and genre from desktop and mobile controls",
      "Open game pages with descriptions, trailers, screenshots, and ratings",
      "Fetch and cache API data with React Query",
      "Manage shared game-query state with Zustand",
    ],
    technologies: [
      "React",
      "TypeScript",
      "Vite",
      "Chakra UI",
      "React Query",
      "Zustand",
      "Axios",
      "RAWG API",
    ],
    liveLink: "https://game-hub-neon-three-66.vercel.app/",
    githubLink: "https://github.com/MuhammadAnas126/game-hub",
  },
  {
    id: 1,
    title: "Smart Cafeteria System",
    description:
      "A sophisticated POS (Point of Sale) application for cafeteria management. Built with Java and JavaFX, it features a sleek, dark-themed UI that streamlines the ordering process through categorized menu selection and real-time order tracking.",
    images: [
      smartCafe1,
      smartCafe2,
      smartCafe3,
      smartCafe4,
      smartCafe5,
      smartCafe6,
      smartCafe7,
      smartCafe8,
      smartCafe9,
      smartCafe10,
      smartCafe11,
      smartCafe12,
      smartCafe13,
    ],
    checklist: [
      "Modern GUI developed with JavaFX and Custom CSS styling",
      "Dynamic order management with real-time bill calculation",
      "Categorized menu system (Fast Food, Pizza, Beverages, etc.)",
      "Automated inventory and price tracking logic",
      "Robust input validation for order quantities",
      "Clean OOP architecture for menu item scalability",
    ],
    features: [
      "Interactive sidebar for real-time order summaries",
      "Multi-category navigation for efficient menu browsing",
      "Visual feedback for item selection and pricing",
      "Automated 'Total Bill' generation including taxes/discounts",
      "User-friendly layout optimized for fast-paced environments",
      "Persistent data handling for menu and pricing updates",
      "Responsive UI design with professional color palettes",
    ],
    technologies: ["Java", "JavaFX", "Scene Builder", "CSS", "OOP Principles"],
    liveLink: "https://youtu.be/jwv4lE5FE1o",
    githubLink: "https://github.com/MuhammadAnas126/OOP-Project",
  },
  {
    id: 2,
    title: "AI Chatbot (GUI & NLP)",
    description:
      "Developed 'CodeAlphaBot,' a virtual assistant with a custom-built Graphical User Interface. The bot processes natural language queries to provide real-time information, such as current time and task assistance, while maintaining a seamless conversational flow.",
    images: [AIchatbot1, AIchatbot2],
    checklist: [
      "Interactive GUI built with JavaFX for a modern user experience",
      "Natural Language Processing (NLP) for intent recognition",
      "Real-time system integration for dynamic responses (e.g., time/date)",
      "Automated conversation logging and state management",
      "Custom CSS-styled chat bubbles and responsive layout",
      "Exception handling for unrecognized user queries",
    ],
    features: [
      "User-friendly messaging interface with 'Send' functionality",
      "Personalized virtual assistant identity (CodeAlphaBot)",
      "Pattern matching for frequently asked questions (FAQs)",
      "Persistent chat history for user reference",
      "Scrollable message viewport for long conversations",
      "Instantaneous response generation",
      "Lightweight and optimized backend logic",
    ],
    technologies: [
      "Java",
      "JavaFX",
      "NLP Fundamentals",
      "Event-Driven Programming",
      "CSS (for GUI styling)",
    ],
    githubLink:
      "https://github.com/MuhammadAnas126/codealpha_tasks/tree/artificial-intelligence-chatbot",
  },
  {
    id: 3,
    title: "Moshify - Cloud Hosting Landing Page",
    description:
      "A professionally designed, high-conversion landing page for a cloud hosting service. Built using pure HTML5 and CSS3, this project showcases advanced layout techniques and a mobile-first responsive strategy without relying on heavy frameworks.",
    images: [moshify1, moshify2, moshify3, moshify4, moshify5],
    checklist: [
      "Semantic HTML5 for improved SEO and accessibility",
      "Advanced CSS Grid and Flexbox for complex layouts",
      "Mobile-first responsive design architecture",
      "Custom CSS components using the BEM naming convention",
      "Optimized SVG graphics and high-resolution image assets",
      "Cross-browser style normalization and consistency",
    ],
    features: [
      "Sleek hero section with call-to-action buttons",
      "Multi-column features grid with custom icons",
      "Interactive-style plan comparison and pricing tables",
      "Optimized typography for readability and visual hierarchy",
      "Modular CSS structure for easy maintenance",
      "Responsive navigation and fluid media elements",
      "Pixel-perfect implementation of modern design patterns",
    ],
    technologies: [
      "HTML5",
      "CSS3",
      "Mobile-First Design",
      "CSS Grid / Flexbox",
      "BEM Methodology",
    ],
    liveLink: "https://deployhub.netlify.app/",
    githubLink: "https://github.com/MuhammadAnas126/First-Website",
  },
  {
    id: 4,
    title: "Student Grade Tracker",
    description:
      "A Java-based desktop application developed to help educators track and analyze student performance. It features a custom GUI for data entry and provides real-time statistical analysis including class averages and performance extremes.",
    images: [gradeChecker1, gradeChecker2, gradeChecker3],
    checklist: [
      "Interactive Desktop GUI for seamless data management",
      "Dynamic grade processing using Java Collections (ArrayList)",
      "Real-time calculation of Average, Highest, and Lowest scores",
      "Persistent data storage with automated saving/loading",
      "Robust input validation for grade ranges (0-100)",
      "Modular architecture following Clean Code principles",
    ],
    features: [
      "Live dashboard for student record visualization",
      "Instant performance metrics and class statistics",
      "Automated record persistence across sessions",
      "User-friendly input forms with placeholder text",
      "Dynamic table updates upon student addition",
      "Error handling for invalid or empty name/grade entries",
    ],
    technologies: [
      "Java",
      "Desktop GUI Development",
      "Data Structures (ArrayList)",
      "File I/O",
      "OOP Principles",
    ],
    githubLink:
      "https://github.com/MuhammadAnas126/codealpha_tasks/tree/student-grade-tracker",
  },
  {
    id: 5,
    title: "Stock Trading Platform",
    description:
      "A logic-intensive trading simulator designed to model financial market behaviors and portfolio management. The platform enables users to monitor real-time stock price fluctuations, execute buy/sell orders based on market trends, and maintain a historical record of all transactions within a performance-optimized console environment.",
    images: [stock1, stock2, stock3, stock4, stock5],
    checklist: [
      "Dynamic market price simulation using algorithmic logic",
      "Efficient portfolio management system using Object-Oriented principles",
      "Transaction history logging with persistent File I/O storage",
      "Execution of market orders with real-time balance updates",
      "Data validation for trade volume and insufficient funds",
      "Modular architecture for scalable financial instrument modeling",
    ],
    features: [
      "Live-simulated ticker for real-time market data visualization",
      "Automated calculation of profit/loss and portfolio valuation",
      "Features a robust transaction engine that accurately tracks net worth, cash balances, and asset valuations across multiple trades.",
      "Secure user balance management and credit tracking",
      "Interactive command-line interface for trade execution",
      "Detailed transaction history export to local text files",
      "Support for multi-stock tracking and dynamic price adjustments",
      "Built-in safeguards against invalid trade operations",
    ],
    technologies: [
      "Java",
      "Data Structures & Algorithms (DSA)",
      "Object-Oriented Programming (OOP)",
      "File I/O",
      "Standard Template Library (STL)",
    ],
    githubLink:
      "https://github.com/MuhammadAnas126/codealpha_tasks/tree/stock-trading-platform",
  },
  {
    id: 6,
    title: "Hotel Reservation System",
    description:
      "A logic-driven console application designed to manage hotel room bookings and guest records. The system features room category filtering (Deluxe, Luxury, Standard), real-time availability tracking, and a secure payment/confirmation workflow.",
    images: [hotel1, hotel2, hotel3],
    checklist: [
      "Object-Oriented design with Guest and Room class entities",
      "Dynamic room search and availability filtering",
      "Automated booking confirmation and ID generation",
      "Logic for multi-category room management and pricing",
      "Input sanitization to prevent double-bookings",
      "Persistent record tracking via console-based state management",
    ],
    features: [
      "Search rooms by specific category (e.g., Deluxe vs. Standard)",
      "Real-time display of available room numbers and prices",
      "Integrated reservation process with guest details input",
      "Detailed booking summaries including room type and total cost",
      "Confirmation system to verify successful reservations",
      "User-friendly terminal navigation with a clean menu structure",
      "Error handling for invalid room choices or capacity limits",
    ],
    technologies: [
      "Java",
      "Data Structures (ArrayList)",
      "Object-Oriented Programming (OOP)",
      "Logic Engineering",
      "CLI (Command Line Interface)",
    ],
    githubLink:
      "https://github.com/MuhammadAnas126/codealpha_tasks/tree/hotel-reservation-system",
  },
];
